import { OutboundSyncStatus } from "@/components/sync/types";
import { useMemo } from "react";
import { SyncState } from "@/components/sync/types";
import { observer } from "mobx-react-lite";
import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds";

interface Props {
  syncState: SyncState;
}

export const SyncStatusIcon = observer(({ syncState }: Props) => {
  const iconKind = useIconKind(syncState.status);
  const iconColor = useIconColor(syncState.status);

  // TODO: Re-enable this once we have inbound sync working
  if (syncState.status === OutboundSyncStatus.Idle) {
    return null;
  }

  return <MDSIcon kind={iconKind} boxSize={16} color={iconColor} />;
});

const useIconKind = (syncStatus: OutboundSyncStatus): MDSIconKind => {
  return useMemo(() => {
    if (syncStatus === OutboundSyncStatus.Paused) {
      return MDSIconKind.CloudSlashFlipped;
    }

    if (syncStatus === OutboundSyncStatus.Syncing) {
      return MDSIconKind.Spinner;
    }

    if (syncStatus === OutboundSyncStatus.Idle) {
      return MDSIconKind.CheckCircleSolid;
    }

    return MDSIconKind.CloudSlashFlipped;
  }, [syncStatus]);
};

const useIconColor = (syncStatus: OutboundSyncStatus): MDSIconColor => {
  return useMemo(() => {
    if (syncStatus === OutboundSyncStatus.Paused) {
      return MDSIconColor.Emphasis;
    }

    if (syncStatus === OutboundSyncStatus.Syncing) {
      return MDSIconColor.Emphasis;
    }

    if (syncStatus === OutboundSyncStatus.Idle) {
      return MDSIconColor.Positive;
    }

    return MDSIconColor.Secondary;
  }, [syncStatus]);
};
